/* eslint-disable no-nested-ternary */
import React from 'react';
import { Link } from 'react-router-dom';

import { isActive, canRunEvents, ClubTierTypes, ClubMemberRoles } from '../../../utils/clubs';
import styles from './clubItem.scss';

const ClubItem = props => {
    const {
        id,
        name,
        statusType,
        clubMemberRole,
        tierTypeId,
        isHighSchool,
        isCollege,
        upgradeToCollege,
        upgradeToPerformanceHs,
    } = props;

    const roleMap = {
        Owner: 'Head Provider',
        Admin: 'Provider',
        Member: 'Member',
        Follower: 'Follower',
    };
    const { label, value } = statusType;
    const roleId = clubMemberRole.id;

    const getClubLinkPath = () => {
        if (isCollege) {
            return 'colleges';
        }

        if (isHighSchool) {
            return 'schools';
        }

        return 'clubs';
    };

    const getColumnActionContent = () => {
        if (roleId !== ClubMemberRoles.Owner && roleId !== ClubMemberRoles.Admin) {
            return null;
        }

        if (roleId === ClubMemberRoles.Owner) {
            if (value === 'suspended' || value === 'paymentrequired') {
                return (
                    <Link to={`/${getClubLinkPath()}/${id}`} data-testid="clubs.club-item.reactivate-link">
                        {value === 'suspended' ? 'Reactivate' : 'Activate Subscription'}
                    </Link>
                );
            }

            const canUpgradeToPerformanceHs = isHighSchool &&
                tierTypeId === ClubTierTypes.HIGH_SCHOOL;

            if (canUpgradeToPerformanceHs) {
                return (<Link onClick={() => upgradeToPerformanceHs(id, name)} data-testid="clubs.club-item.upgrade-hs-link"> Upgrade to Performance High School</Link>);
            }
        }

        if (isActive(props) && canRunEvents(props)) {
            if (tierTypeId === 1) {
                return (<Link to={`/events/create-group-play?clubId=${id}`} data-testid="clubs.club-item.schedule-play-link">Schedule Play</Link>);
            }

            return (<Link to={`/events/create?clubId=${id}`} data-testid="clubs.club-item.create-event-link">Create Event</Link>);
        }

        if (isCollege && tierTypeId === 4) {
            return (<Link onClick={() => upgradeToCollege(id, name)} data-testid="clubs.club-item.upgrade-college-link"> Upgrade to College Coach Subscription</Link>);
        }
    };

    return (
        <div className={`${styles.clubItem} d-flex`} data-testid="clubs.club-item">
            <div className={`col-md-5 col-4 ${styles.clubItemColumn}`}>
                <Link to={`/${getClubLinkPath()}/${id}`} data-testid="clubs.club-item.name-link">
                    {name}
                </Link>
            </div>
            <div className={`col-md-2 d-none d-md-block ${styles.clubItemColumn}`} data-testid="clubs.club-item.status">
                {roleId === ClubMemberRoles.Owner && label}
            </div>
            <div className={`col-md-2 col-4 ${styles.clubItemColumn}`} data-testid="clubs.club-item.role">{roleMap[clubMemberRole.value]}</div>
            <div className={`col-md-3 col-4 ${styles.clubItemColumn}`} data-testid="clubs.club-item.action">
                {getColumnActionContent()}
            </div>
        </div>
    );
};

export default ClubItem;
